<template>
  <div class="col-md-12" v-if="settings">
    <div class="title-heading d-flex justify-content-between">
      <h1>{{ $static('s-b.title', 'Налаштування магазину') }}</h1>
    </div>
    <div class="integration-grid setting-grid">

      <!--! Плашки с настройками магазина -->
      <!-- Плашка №1 -->
      <SettingsModalBox modalBoxTypeClass='basic-settings-modal-box'
        @saveSettingsEvent="(payload) => { this.handleSaveBtnClick(payload, this.validateBasicSettings) }"
        @settingsInitialized="settingsInitialized = true" @cancelSaveSettingsEvent="closeSettingsModalBox"
        :isLoading="load">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.sett1', 'Базові налаштування') }}
            </div>
            <div class="desc">
              {{
                $static('s-b.sett-desc1', 'Logo, favicon, контакти, соц. мережі, Web Hook, управління каталогом')
              }}
            </div>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <!-- 1 начало-->
          <div class="row row-device">
            <div class="col-lg-6 col-md-12">
              <h3>{{ $static('s-b.logo', 'Лого сайту') }}</h3>
              <div class="custom-label" style="color:#565656; margin-top: 15px; font-style: italic;line-height: 1.3;">
                {{
                  $static('s-b.t222', 'Максимальний рекомендований розмір 120 x 55 px')
                }}
              </div>
              <div class="files-uploader default-files-uploader logo-uploader" @click="openFileManager">
                <div class="files-uploader-holder" v-if="!logoSrc" @click="openFileManager">
                  <span class="icon icon-cloud-upload"></span>
                  <p>{{ $static('ei.tf1', 'Завантажте свої зображення сюди') }}</p>
                  <span>{{ $static('ei.tf2', 'Зображення повинні мати розширення png або jpg') }}</span>
                </div>

                <div class="uploader-previews" v-else>
                  <div class="image bg" :style="{ backgroundImage: $filters.backgroundImage(logoSrc) }" :path="logoSrc">
                    <a href="javascript:void(0)" class="btn-icon btn-remove btn-small" @click.prevent.stop="delImage"
                      v-if="logoSet">
                      <span class="icon icon-trash-filled"></span>
                    </a>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-lg-6 col-md-12">
              <h3>{{ $static('s-b.favicon', 'Favicon') }}</h3>
              <div class="custom-label" style="color:#565656; margin-top: 15px; font-style: italic;line-height: 1.3;">
                {{ $static('s-b.t222', 'Максимальний рекомендований розмір 50 x 50 px') }}
              </div>
              <div class="files-uploader default-files-uploader logo-uploader" @click="openFileManagerFavicon">
                <div class="files-uploader-holder" v-if="!faviconSrc" @click="openFileManager">
                  <span class="icon icon-cloud-upload"></span>
                  <p>{{ $static('ei.tf1', 'Завантажте свої зображення сюди') }}</p>
                  <span>{{ $static('ei.tf2', 'Зображення повинні мати розширення png або jpg') }}</span>
                </div>

                <div class="uploader-previews" v-else>
                  <div class="image bg" :style="{ backgroundImage: $filters.backgroundImage(faviconSrc) }">
                    <a href="javascript:void(0)" class="btn-icon btn-remove btn-small" @click.prevent.stop="delFavicon"
                      v-if="faviconSet">
                      <span class="icon icon-trash-filled"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 1 конец-->
          <!-- 2 начало-->
          <h3 class="mt-2">{{ $static('s-b.dcatt1', 'Управління каталогом') }}</h3>
          <div class="row">
            <div class="col">
              <div class="panel panel-bordered">
                <div class="option-line mt-0">
                  <div class="option-name">{{ $static('s-b.dcatt2', 'Сіточка по 2 позиції') }}</div>
                  <div class="empty"></div>
                  <div class="toggle-holder">
                    <div class="toggler r">
                      <input type="checkbox" v-model="settings.public.catalog_duo" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="panel panel-bordered">
                <div class="option-line  mt-0">
                  <div class="option-name">{{ $static('s-b.dcatt3', 'Вимкнути формулу ціни у товарі') }}</div>
                  <div class="empty"></div>
                  <div class="toggle-holder">
                    <div class="toggler r">
                      <input type="checkbox" v-model="settings.public.formula" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-device">
            <div class="col">
              <label class="custom-label">{{ $static('s-b.label-quantity', 'Кількість відображених міток:') }}</label>
              <input type="number" class="form-control custom-input" :placeholder="3" min="0" max="10"
                v-model="settings.public.labelQuantity" @input="validateInteger($event, 'labelQuantity')">
            </div>
            <div class="col"></div>
          </div>

          <!-- 2 конец-->
          <h3 class="mt-2">{{ $static('s-b.ltitle', 'Мови:') }}</h3>
          <div class="form-group mb-0">
            <label class="custom-label">{{
              $static('s-b.ltext', 'Оберіть мову магазину (по одному за один клік)')
            }}</label>
            <label class="custom-label">{{ $static('s-b.ltext2',
              'Оберіть якщо немає жодної. Меню вибору не буде відображатись.') }}</label>
            <!--                  <input type="text" class="form-control custom-input" placeholder="Обрати мову">-->
            <div class="selector-holder" style="margin-top: 15px;">
              <v-select id="together_products" :searchable="false" :title="$static('sb.adl', 'Додати мову')"
                :placeholder="$static('sb.sdlp', 'Додати мову')" :options="langLists" v-model="langAdd">
                <template #option="{ label, item }" class="together_list-item">
                  <p style="margin: 0">{{ label }}</p>
                  <!--                        <img v-if="item.images.length" :src="item.images[0]">-->
                </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                        fill="#212121" />
                    </svg>
                  </span>
                </template>
              </v-select>

            </div>
            <div class="custom-tags tags tags-together">
              <div class="tag" v-for="(tag, index) in langs" :key="index">
                {{ tag.label }}
                <!--                      <img v-if="tag.image" :src="tag.image">-->
                <a href="javascript:void(0)" @click.prevent.stop="removeLang(index)" class="tag-remove">
                  <span class="icon icon-cross"></span>
                </a>
              </div>
            </div>

          </div>
          <!-- 3 начало-->
          <h3 class="mt-2">{{ $static('s-b.contact', 'Контакти') }}</h3>
          <div class="form-group">
            <label class="custom-label">{{ $static('s-b.email', 'Електронна пошта:') }}</label>
            <input type="text" class="form-control custom-input" placeholder="example@gmail.com"
              v-model="settings.public.email">
          </div>
          <div class="form-group">
            <label class="custom-label">{{ $static('s-b.phone', 'Телефон:') }}</label>
            <input type="text" class="form-control custom-input" placeholder="+380999998999"
              v-model="settings.public.phone">
          </div>
          <div class="form-group">
            <label class="custom-label">{{ $static('s-b.txtllft', 'Доп інфо:') }}</label>
            <input type="text" class="form-control custom-input"
              :placeholder="$static('s-b.additional-info', 'Графік роботи: 10.00 - 21.00')"
              v-model="settings.public.s_info">
          </div>
          <!-- 3 конец-->
          <!-- 4 начало-->
          <h3 class="mt-3">{{ $static('s-b.social', 'Соціальні мережі') }}</h3>
          <div class="repeat-social row mb-2"
            v-for="(socialNetwork, socialNetworkIdx) in settings.public.socialNetworks" :key="socialNetworkIdx">
            <div class="form-group col-5 mb-0">
              <label class="custom-label">{{ $static('s-b.social-network-name-header', 'Назва') }}</label>
              <input type="text" class="form-control custom-input" placeholder="Telegram" v-model="socialNetwork.name">
            </div>
            <div class="form-group col-6 mb-0">
              <label class="custom-label">{{ $static('s-b.social-network-link-header', 'Посилання') }}</label>
              <input type="text" class="form-control custom-input" placeholder="https://t.me/durov"
                v-model.trim="socialNetwork.link">
            </div>
            <div class="actions-box d-flex align-items-center justify-content-center col" style="padding-top: 20px">

              <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                style="white-space: nowrap">
                <button type="button" class="btn-icon btn-rounded btn-icon-transparent btn-remove"
                  @click="removeSocialNetwork(socialNetworkIdx)">
                  <span class="icon icon-trash"></span>
                </button>
              </Popper>
            </div>

          </div>
          <div class="repeat-button mt-2">
            <button class="default-btn btn-with-icon btn-white btn-green mt-2" @click="addSocialNetwork">
              <span class="text">{{ $static('s-b.soc-add', 'Додати мережу:') }}</span>
              <span class="icon icon-add"></span>
            </button>
          </div>
          <!-- 4 конец-->
          <!-- 5 начало-->
          <h3 class="mt-3">{{ $static('s-b.webhook', 'Web Hook') }}</h3>
          <div class="form-group">
            <label class="custom-label">{{ $static('s-b.wbhlink', 'Посилання на вебхук') }}</label>
            <input type="text" class="form-control custom-input" placeholder="https://t.me/uxlovebot"
              v-model.trim="settings.env.WEBHOOK">
          </div>
          <!-- 5 конец-->
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>

      <!-- Плашка №2 -->
      <SettingsModalBox modalBoxTypeClass='telegram-settings-modal-box'
        @saveSettingsEvent="(payload) => { this.handleSaveBtnClick(payload, this.validateTelegramSettings) }"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.sett2', 'Налаштування Telegram') }}
            </div>
            <div class="desc">{{ $static('s-b.sett-desc2', 'Токен, ідентифікатори, посилання') }}</div>
          </div>
          <div class="button-panel">
            <a href="#" class="btn-icon btn-icon-outline btn-rounded btn-icon-transparent editor_trigger">
              <span class="icon icon-settings"></span>
            </a>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <h3>{{ $static('s-b.tg', 'Налаштування Telegram:') }}</h3>
          <div class="form-group">
            <div class="row">
              <div class="col-9">
                <label class="custom-label">
                  {{ $static('s-api.tg', 'Токен телеграм-бота:') }}
                  <router-link :to="{ name: 'AdminSupport' }" style="text-decoration: underline">
                    {{ $static('s-api.inst', 'інструкція') }}
                  </router-link>
                </label>
                <input type="text" class="form-control custom-input" @input="changeBOT = true"
                  v-model.trim="settings.env.TELEGRAM_BOT_TOKEN"
                  placeholder="1111111111:AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA">
              </div>
              <div class="col-3">
                <button class="default-btn btn-white btn-green " @click="validateToken" style="margin-top: 25px;">{{
                  $static('s-api.token-verify-btn', 'Перевірити') }}</button>
              </div>
            </div>
            <span v-if="changeBOT" style="margin-top: 15px;">{{ $static('s-api.nsave', 'Збережіть зміни') }}</span>
          </div>

          <div class="form-group">
            <label class="custom-label with-pre"
              v-html="$static('s-b.ownerID', 'ID власника магазину або группи для перевірки повідомлень перед россилкою')">
            </label>
            <input type="text" class="form-control custom-input" placeholder="1111111111"
              v-model.trim="settings.env.OWNER_ID">
          </div>

          <div class="form-group">
            <label class="custom-label with-pre"
              v-html="$static('s-b.tgwebhook', 'Телеграм Webhook. Якщо ви хочете підєднати сторонній сервіс')">
            </label>
            <input type="text" class="form-control custom-input" placeholder="https://....."
              v-model.trim="settings.env.TG_WEBHOOK">
          </div>

          <div class="form-group">
            <label class="custom-label">{{ $static('s-api.constl', 'Посилання на консультанта') }}</label>
            <input type="text" class="form-control custom-input" v-model="settings.public.consultant"
              placeholder="https://t.me/uxlovebot">
          </div>

          <div class="form-group">
            <label class="custom-label">{{ $static('s-api.pages', 'Лінк Telegram Smart App') }}</label>
            <input type="text" class="form-control custom-input" v-model="settings.env.TGLINK"
              placeholder="https://t.me/uxlovebot/app">
            <p>{{ $static('s-api.smart-app-description-text',
              'У вас є можливість створити динамічний смарт лінк для всіх товарів вашого магазину.') }}</p>
            <p>{{ $static('s-api.smart-app-description-text2',
              'Вам потрібно створити Smart Web App з посинанням: ') }} {{ info.link }}pages</p>
          </div>

        </template>
        <!-- * -------------------------- -->

      </SettingsModalBox>

      <!-- Плашка №3 -->
      <SettingsModalBox modalBoxTypeClass='service-request-settings-modal-box' @saveSettingsEvent="handleSaveBtnClick"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load" hasTranslate="true">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">{{ $static('s-b.lead-settings-title2', 'Налаштування заявок на послуги') }}
            </div>
            <div class="desc">{{ $static('s-b.sett-desc4', '') }}</div>
          </div>
        </template>

        <template v-slot:lang>
          <div class="panel-top">
            <div class="lang-selector-holder d-flex align-items-center">
              <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:')
                }}</label>
              <LangSelector v-model="selectLang"></LangSelector>
            </div>

            <a href="javascript:void(0);" class="back_trigger"
              @click="() => { closeSettingsModalBox('service-request-settings-modal-box') }">
              <span class="icon icon-cross"></span>
            </a>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <div class="row">
            <div class="col">
              <div class="panel panel-bordered">
                <div class="option-line mt-0">
                  <div class="option-name">{{ $static('s-b.mode-text', 'Режим каталогу') }}</div>
                  <div class="empty"></div>
                  <div class="toggle-holder">
                    <div class="toggler r">
                      <input type="checkbox" v-model="isCatalogMod" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="basket-settings-panel">
                <label class="custom-label mt-3 mb-2">
                  {{ $static('s-b.ordtext3_01', 'Основні поля в модальному вікні') }}
                </label>
                <div class="basket-settings-top-line">
                  <div class="name name-field">{{ $static('s-b.ordtext3_02', 'Поле') }}</div>
                  <div class="name name-first text-center">{{ $static('s-b.ordtext31', 'Обовязкове поле') }}</div>
                  <div class="name name-last text-center">{{ $static('s-b.ordtext32', 'Включити/відключити') }}</div>
                </div>
                <div class="basket-settings">
                  <div class="panel panel-bordered">

                    <div class="option-line mt-0">
                      <div class="option-name">{{ $static('s-b.ordtext3n', 'Ім\'я') }}</div>
                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.name_require" class="toggle-check">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>

                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.name" class="toggle-check">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>

                    <div class="option-line">
                      <div class="option-name">{{ $static('s-b.ordtext3p', 'Телефон') }}</div>
                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.phone_require" class="toggle-check" disabled>
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.phone" class="toggle-check" disabled>
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>

                    <div class="option-line">
                      <div class="option-name">{{ $static('s-b.ordtext3e', 'Email') }}</div>
                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.email_require" class="toggle-check">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.email" class="toggle-check">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>

                    <div class="option-line">
                      <div class="option-name">{{ $static('s-b.modal-date', 'Дата') }}</div>
                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.date_require" class="toggle-check">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                      <div class="toggle-holder d-flex justify-content-center">
                        <div class="toggler r">
                          <input type="checkbox" v-model="modal.date" class="toggle-check">
                          <div class="knobs"></div>
                          <div class="layer"></div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--! Настройки дополнительных полей модального окна заявки услуг -->
          <template v-if="modal.fields?.length">
            <div class="basket-settings-panel additional-request-panel">
              <label class="custom-label mt-3 mb-2">{{
                'Додаткові поля в модальному вікні'
              }}</label>
              <div class="basket-settings-top-line">
                <div class="name name-first">{{ $static('s-b.field_name', 'Назва поля') }}</div>
                <div class="name  text-center">{{ $static('s-b.field_type', 'Тип поля') }}</div>
                <div class="name  text-center">{{ $static('s-b.ordtext31', 'Обов\'язкове поле') }}</div>
                <div class="name  text-center">{{ $static('s-b.ordtext334', 'Вкл/відкл') }}</div>
                <div class="name name-last text-center">{{ $static('s-b.ordtext333', 'Виконати дії') }}</div>
              </div>
              <div class="basket-settings">
                <div class="panel panel-bordered">
                  <div v-for="(field, index) in fields" class="option-line" :key="index">

                    <input v-if="selectLang === ''" type=" text" class="form-control custom-input"
                      style="margin-right: 20px; width:auto;" v-model="field.name"
                      :placeholder="$static('s-b.field_placeholder', 'Введiть назву поля')" />

                    <input v-else type="text" class="form-control custom-input" style="margin-right: 20px; width:auto;"
                      v-model="field.translate[this.selectLang].name"
                      :placeholder="$static('s-b.field_placeholder', 'Введiть назву поля')" />
                    <select v-model="field.type" class="form-control custom-input">
                      <option selected value="text">{{ $static('s-b.text-field-type', 'Текстове') }}</option>
                      <option value="number">{{ $static('s-b.number-field-type', 'Числове') }}</option>
                      <option value="file" :disabled="isFileFieldExist">
                        {{ $static('s-b.file-field-type', 'Для файлів та зображень') }}</option>
                    </select>

                    <div class="toggle-holder d-flex justify-content-center">
                      <div class="toggler r">
                        <input type="checkbox" v-model="field.isRequired" class="toggle-check">
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div>
                    <div class="toggle-holder d-flex justify-content-center">
                      <div class="toggler r">
                        <input type="checkbox" v-model="field.enabled" class="toggle-check">
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div>
                    <div class="actions-box d-flex justify-content-end">
                      <Popper arrow :content="$static('iconsbtn.up', 'Нагору')" hover placement="top"
                        style="white-space: nowrap">
                        <button type="button" class=" btn-icon btn-rounded btn-icon-transparent "
                          @click="swap(index, index - 1)">
                          <span class="icon icon-up"></span>
                        </button>
                      </Popper>
                      <Popper arrow :content="$static('iconsbtn.down', 'Вниз')" hover placement="top"
                        style="white-space: nowrap">
                        <button type="button" class=" btn-icon btn-rounded btn-icon-transparent "
                          @click="swap(index, index + 1)">
                          <span class="icon icon-down"></span>
                        </button>
                      </Popper>
                      <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                        style="white-space: nowrap">
                        <button type="button" class="btn-icon btn-rounded btn-icon-transparent btn-remove"
                          @click="removeModalField(index)">
                          <span class="icon icon-trash"></span>
                        </button>
                      </Popper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!--! Конец настроек дополнительных полей модального окна заявки услуг -->
          <div class="repeat-button mt-2">
            <button class="default-btn btn-with-icon btn-white btn-green mt-2" @click="addCustomField">
              <span class="text">{{ $static('s-b.sett-field-add', 'Додати поле:') }}</span>
              <span class="icon icon-add"></span>
            </button>
          </div>
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>

      <!--! Плашка №4 -->
      <SettingsModalBox modalBoxTypeClass='backoffice-settings-modal-box'
        @saveSettingsEvent="(payload) => { this.handleSaveBtnClick(payload, this.validateBackofficeSettings) }"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.backof', 'Сповіщення в телеграм') }}
            </div>
            <div class="desc">
              {{ $static('s-b.backof-desc', 'Ідентифікатор каналу/групи, Лінк Telegram Web App, Manager ID') }}
            </div>
          </div>
          <div class="button-panel">
            <a href="#" class="btn-icon btn-icon-outline btn-rounded btn-icon-transparent editor_trigger">
              <span class="icon icon-settings"></span>
            </a>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <h3>{{ $static('s-b.backof', 'Сповіщення в телеграм') }}</h3>

          <div class="panel panel-bordered panel-bg">
            <div class="form-group mb-0">
              <label class="custom-label with-pre" v-html="$static('s-b.ntfmngr', 'Лінк вашого Telegram Web App')">
              </label>
              <input type="text" class="form-control custom-input" placeholder="https://t.me/yourbot/yourshortlink"
                v-model="settings.env.MANAGER_LINK">
              <div class="desc-text mt-2">
                <span>{{ $static('s-b.backof-description-text',
                  'У вас є можливість обробляти ваші замовлення прямо у телеграм.') }}
                  <br /> {{ $static('s-b.backof-description-text2', 'Вам потрібно створити Smart Web App з посиланням:')
                  }} <a :href="admin_link">{{ admin_link }}</a>
                </span>
              </div>
            </div>
          </div>

          <div class="panel panel-bordered panel-bg">
            <div class="form-group mb-0">
              <label class="custom-label">{{ $static('s-b.backof-handle-order-id',
                'Ідентифікатор каналу/групи для обробки замовлення') }}</label>

              <input type="text" class="form-control custom-input" placeholder="##########"
                v-model="settings.env.NOTIFY_ID">
              <div class="desc-text mt-2">
                <span>{{ $static('s-b.backof-handle-order-text',
                  'Додайте бота до групи/каналу з правами адміністратора та введіть команду') }}
                  <span class="bot-command-text">/me </span>
                  {{ $static('s-b.backof-handle-order-text2', ' своєму боту та отримайте ID') }} </span>
              </div>
            </div>

          </div>
          <div class="form-group">
            <label class="custom-label"
              v-html="$static('s-b.ntftext2', 'Ідентифікатор каналу/групи для відправки замовлення.')"></label>
            <input type=" text" class="form-control custom-input" placeholder="##########"
              v-model="settings.env.BACKOFFICE_MANAGER_2">
          </div>
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>

      <!-- Плашка №5 -->
      <SettingsModalBox modalBoxTypeClass='currency-settings-modal-box' @saveSettingsEvent="handleSaveBtnClick"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.ctitle', 'Валюти') }}
            </div>
            <div class="desc">{{ $static('s-b.sett-desc4', '') }}</div>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <h3>{{ $static('s-b.ctitle', 'Валюти:') }}</h3>
          <div class="row">
            <div class="col">
              <div class="form-group mb-0">
                <label class="custom-label">{{ $static('s-b.ctext1', 'Валюта для відображення ціни') }}</label>
                <input type="text" class="form-control custom-input" :placeholder="$static('s-b.cph', 'Введіть символ')"
                  v-model="symbol">
              </div>
            </div>
            <div class="col">
              <div class="form-group mb-0">
                <label class="custom-label">{{ $static('s-b.ctext2', 'Валюта для фактичних оплат') }}</label>
                <v-select id="editor_category" :options="currList" :searchable="false" v-model="currency"
                  :reduce="c => c.value" class="currency-select" @option:selected="(e) => onChangeStatus(e, item)">
                  <template #selected-option="{ label, c }">
                    <p style="margin: 0" :class="c">{{ label }}</p>
                  </template>
                  <template #option="{ label, c }" class="together_list-item">
                    <p style="margin: 0" :class="c">{{ label }}</p>
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                          fill="#212121" />
                      </svg>
                    </span>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>

      <!-- Плашка №6 -->
      <SettingsModalBox modalBoxTypeClass='basket-settings-modal-box' @saveSettingsEvent="handleSaveBtnClick"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.ordtitle', 'Кошик') }}
            </div>
            <div class="desc">{{ $static('s-b.sett-desc4', '') }}</div>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <div class="basket-settings-panel">
            <div class="form-group ">
              <div class="info-block">
                <label class="custom-label">{{ $static('s-b.bmin', 'Мінімальне замовлення') }}</label>
              </div>
              <input type="text" class="form-control custom-input" placeholder="0" v-model.number="busked.min_price">
            </div>

            <label class="custom-label">{{ $static('s-b.ordtext', 'Персональні данні') }}</label>
            <div class="basket-settings-top-line">
              <div class="name name-field">{{ $static('s-b.ordtext33', 'Поля в корзині') }}</div>
              <div class="name name-first text-center">{{ $static('s-b.ordtext31', 'Обовязкове поле') }}</div>
              <div class="name name-last text-center">{{ $static('s-b.ordtext32', 'Включити/відключити') }}</div>
            </div>
            <div class="basket-settings">
              <div class="panel panel-bordered">
                <div class="option-line mt-0">
                  <div class="option-name">{{ $static('s-b.ordtext3n', 'Ім\'я') }}</div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.name_require" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>

                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.name" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>

                <div class="option-line ">
                  <div class="option-name">{{ $static('s-b.ordtext3sn', 'Прізвище') }}</div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.sname_require" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>

                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.sname" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>

                <div class="option-line">
                  <div class="option-name">{{ $static('s-b.ordtext3p', 'Телефон') }}</div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.phone_require" class="toggle-check" disabled>
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.phone" class="toggle-check" disabled>
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>

                <div class="option-line ">
                  <div class="option-name">{{ $static('s-b.ordtext3e', 'Email') }}</div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.email_require" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.email" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>

                <div class="option-line ">
                  <div class="option-name">{{ $static('s-b.ordtext3c', 'Коментар') }}</div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.comment_require" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                  <div class="toggle-holder d-flex justify-content-center">
                    <div class="toggler r">
                      <input type="checkbox" v-model="busked.comment" class="toggle-check">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>

      <!-- Плашка №7 -->
      <SettingsModalBox modalBoxTypeClass='bonus-settings-modal-box' @saveSettingsEvent="handleSaveBtnClick"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.sett3', 'Налаштування бонусів') }}
            </div>
            <div class="desc">{{ $static('s-b.sett-desc3', 'Стартовий, максимальний, загальні бонуси') }}</div>
          </div>
          <div class="button-panel">
            <a href="#" class="btn-icon btn-icon-outline btn-rounded btn-icon-transparent editor_trigger">
              <span class="icon icon-settings"></span>
            </a>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <h3>{{ $static('s-b.tgb', 'Налаштування Бонусів:') }}</h3>
          <div class="form-group">
            <label class="custom-label">{{ $static('s-api.sbonus', 'Стартовий бонус') }}</label>
            <input type="text" class="form-control custom-input" v-model.number="settings.env.START_BONUS"
              placeholder="0">
          </div>

          <div class="form-group">
            <label class="custom-label">{{ $static('s-api.maxbonus', 'Максимальний % для сплати бонусами') }}</label>
            <input type="text" class="form-control custom-input" v-model.number="settings.env.MAX_BONUS"
              placeholder="100">
          </div>

          <div class="form-group ">
            <div class="info-block">
              <label class="custom-label">{{ $static('s-b.bmul', 'Бонуси %') }}</label>
              <Popper arrow
                :content="$static('s-b.bmult', 'Якщо вказати 5: Після оплати товару на 100 грн, клієнту буде нараховано 5 бонусів.')"
                hover placement="top">
                <span class="cs-trigger-info">?</span>
              </Popper>
            </div>
            <input type="text" class="form-control custom-input" :placeholder="$static('s-b.cph3', '5')"
              v-model.number.lazy="multiplier_bonus">
          </div>
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>

      <!-- Плашка №8 -->
      <SettingsModalBox modalBoxTypeClass='analytics-settings-modal-box' @saveSettingsEvent="handleSaveBtnClick"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.atitle', 'Аналітика') }}

            </div>
            <div class="desc">{{ $static('s-b.sett-desc4', '') }}</div>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:content>
          <h3>{{ $static('s-b.atitle', 'Аналітика:') }}</h3>
          <div class="form-group ">
            <label class="custom-label">{{ $static('s-b.aitem2', 'Facefook Pixel') }}</label>
            <textarea class="form-control custom-input" placeholder="<!-- Facebook Pixel Code -->"
              v-model="settings.public.code2"></textarea>
          </div>
          <div class="form-group mb-0">
            <label class="custom-label">{{ $static('s-b.aitem3', 'Header') }}</label>
            <textarea class="form-control custom-input" :placeholder="$static('s-b.aph', 'Вставте код')"
              v-model="settings.public.code3"></textarea>
          </div>
          <div class="form-group mb-0">
            <label class="custom-label">{{ $static('s-b.aitem4', 'Body') }}</label>
            <textarea class="form-control custom-input" :placeholder="$static('s-b.aph', 'Вставте код')"
              v-model="settings.public.body"></textarea>
          </div>
          <div class="form-group">
            <label class="custom-label">{{ $static('s-b.aitem1-1', 'Style') }}</label>
            <textarea class="form-control custom-input" placeholder="<style></style>"
              v-model="settings.public.code1"></textarea>
          </div>
          <!--                  <div class="form-group mb-0">-->
          <!--                    <label class="custom-label">{{ $static('s-b.aitem4', 'SEO text для каталога') }}</label>-->
          <!--                    <textarea class="form-control custom-input" :placeholder="$static('s-b.aph', 'Вставте код')"-->
          <!--                              v-model="settings.public.catalogSeo"></textarea>-->
          <!--                  </div>-->
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>

      <!-- Плашка №9 -->
      <SettingsModalBox modalBoxTypeClass='reviews-settings-modal-box' @saveSettingsEvent="handleSaveBtnClick"
        @cancelSaveSettingsEvent="closeSettingsModalBox" @settingsInitialized="settingsInitialized = true"
        :isLoading="load" hasTranslate="true">
        <!--* Описание плашки -->
        <template v-slot:description>
          <div class="item-text">
            <div class="name">
              {{ $static('s-b.rtitle', 'Налаштування відгуків') }}
            </div>
            <div class="desc">{{ $static('s-b.sett-desc4', '') }}</div>
          </div>
        </template>
        <!-- * -------------------------- -->

        <!-- * Содержимое окна настроек этой плашки -->
        <template v-slot:lang>
          <div class="panel-top">
            <div class="lang-selector-holder d-flex align-items-center">
              <label v-if="langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
              <LangSelector v-model="selectLang"></LangSelector>
            </div>

            <a href="javascript:void(0);" class="back_trigger"
              @click="() => { closeSettingsModalBox('reviews-settings-modal-box') }">
              <span class="icon icon-cross"></span>
            </a>
          </div>
        </template>

        <template v-slot:content>
          <h3>{{ $static('s-b.rtitle', 'Налаштування відгуків') }}</h3>
          <div class="form-group">
            <label class="custom-label">{{ $static('s-b.rtags-title', 'Теги') }}
            </label>
            <input v-if="selectLang === ''" type="text" class="form-control custom-input"
              placeholder="🥰 Гарне обслуговування, 🚀 швидка доставка" v-model="reviewTags">
            <input v-else type="text" class="form-control custom-input"
              :placeholder="$static('s-b.review-tags-plceholder', '🥰 Гарне обслуговування, 🚀 швидка доставка')"
              v-model="translateReviewTags[this.selectLang].reviewTags">
          </div>

          <div class="form-group">
            <label class="custom-label with-pre" style="line-height: 1.3;margin-bottom:15px;">
              {{ $static('s-b.review-max-photos-title', 'Максимальна кількість фото у відгуку') }}
            </label>
            <input type="number" min="0" max="1000" class="form-control custom-input" placeholder="10"
              v-model="settings.public.maxReviewPhotos" @input="validateInteger($event, 'maxReviewPhotos')">
          </div>
        </template>
        <!-- * -------------------------- -->
      </SettingsModalBox>
    </div>
  </div>
</template>

<script>
import api from '@/api'
// import SettingsBasicBuskedEditor from '@/components/SettingsBasicBuskedEditor';
import SettingsModalBox from '@/components/SettingsModalBox';
import LangSelector from '@/components/LangSelector';

export default {
  name: 'SettingsBasic',
  components: { SettingsModalBox, LangSelector },
  data() {
    return {
      load: false,
      settingsInitialized: false, // флаг для отслеживания инициализации
      areSettingsChanged: false,
      changeBOT: false,
      template: {},
      currList: [],
      langLists: [],
      selectLang: '',
      settings: {
        public: {},
        env: {}
      },
      items: [],
      filter: {
        page: 1,
        perPage: 10
      }
    }
  },

  async mounted() {
    await this.fetchSettings();
    await this.fetchMeta();
  },

  computed: {
    info() {
      return this.$store.getters.info
    },
    admin_link() {
      return window.location.protocol + "//" + window.location.host + "/manager"
    },
    first_item_id() {
      return this.items?.length ? this.items[0].id : 1
    },
    fields() {
      const defaultTranslate = {
        en: { name: '' },
        ru: { name: '' },
        ua: { name: '' },
      };

      if (this.modal?.fields?.length) {
        this.modal.fields.forEach(field => {
          if (!field.translate) {
            // Создаем копию объекта defaultTranslate для каждого поля
            field.translate = JSON.parse(JSON.stringify(defaultTranslate));
          }
        });
        return this.modal.fields.sort((a, b) => a.order - b.order);
      }
      return [];
    },

    isFileFieldExist() {
      if (this.fields && this.fields.length > 0) {
        return this.fields.some(fieldObj => fieldObj?.type === "file");
      }
      return false
    },
    logoSrc() {
      return this.logoSet ? this.settings.public.logo : ''
    },

    multiplier_bonus: {
      get() {
        if (!this.settings.env.multiplier_bonus) {
          return 0
        }
        return (this.settings.env.multiplier_bonus * 100).toFixed(0)
      },
      set(value) {
        if (value) {
          this.settings.env.multiplier_bonus = (value / 100).toFixed(2)
        } else {
          this.settings.env.multiplier_bonus = value.toFixed(0)
        }
      }
    },
    faviconSrc() {
      return this.faviconSet ? this.settings.public.favicon : ''
    },
    logoSet() {
      return !!this.settings.public.logo
    },
    faviconSet() {
      return !!this.settings.public.favicon
    },
    aboutHTML() {
      return this.template['about'] ? this.template['about'].template : ''
    },
    langs: {
      get() {
        if (!this.settings.public.lang) {
          this.settings.public.lang = []
        }
        return this.settings.public.lang
      },
      set(value) {
        this.settings.public.lang = value
      }
    },

    busked: {
      get() {
        if (!this.settings.public.busked) {
          this.settings.public.busked = {
            min_price: 0,
            name: true,
            name_require: true,
            sname: true,
            phone: true,
            phone_require: true,
            comment: true,
            delivery: true
          }
        } else {
          this.settings.public.busked.phone = true;
          this.settings.public.busked.phone_require = true;
        }
        return this.settings.public.busked;
      },
      set(value) {
        this.settings.public.busked = value
      }
    },

    modal: {
      get() {
        if (!this.settings.public.modal) {
          this.settings.public.modal = {
            name: true,
            name_require: true,
            date: true,
            date_required: true,
            phone: true,
            phone_require: true,
            email: true,
            email_require: true
          }
        }
        //Железно устанавливаем поля телефона обязательными, а в виду атрибута disabled на инпутах - не изменяемыми
        this.settings.public.modal.phone = true;
        this.settings.public.modal.phone_require = true;

        return this.settings.public.modal
      },
      set(value) {
        this.settings.public.modal = value
      }
    },

    currency: {
      get() {
        if (!this.settings.env.CURRENCY) {
          this.settings.env.CURRENCY = []
        }
        return this.settings.env.CURRENCY
      },
      set(value) {
        this.settings.env.CCY = value;
        this.settings.env.CURRENCY = this.currList.find(i => i.value === value).label
      }
    },

    symbol: {
      get() {
        if (!this.settings.env.CURRENCY) {
          this.settings.public.symbol = []
        }
        return this.settings.public.symbol
      },
      set(value) {
        this.settings.public.symbol = value;
        this.settings.env.C_SYMBOL = value;
      },
      deep: true
    },

    langAdd: {
      get() {
        return ''
      },
      set(value) {
        if (Array.isArray(this.settings.public)) {
          this.settings.public = {}
        }
        try {
          if (this.settings.public.lang.length === 0) {
            if (this.settings.env.LANG) {
              let check = this.langLists.find(x => x.short.toLowerCase() === this.settings.env.LANG);
              if (check && check.short !== value.short) {
                this.settings.public.lang.push(check)
              }
            }
          }
          let idx = this.settings.public.lang.findIndex(x => x.value === value.value);
          if (idx === -1) {
            this.settings.public.lang.push(value)
          }
        } catch (e) {
          let result = [];
          if (this.settings.env.LANG) {
            let check = this.langLists.find(x => x.short.toLowerCase() === this.settings.env.LANG);
            if (check && check.short !== value.short) {
              result.push(check)
            }
          }
          result.push(value);
          this.settings.public.lang = result
        }
      }
    },

    socialNetworks: {
      get() {
        if (!this.settings.public?.socialNetworks) {
          this.settings.public.socialNetworks = []
        }
        return this.settings.public.socialNetworks
      },
      set(value) {
        if (Array.isArray(value)) {
          this.settings.public.socialNetworks = value;
        } else {
          throw new Error('Значение должно быть массивом');
        }
      }
    },

    reviewTags: {
      get() {
        return this.settings.public?.tags?.reviewTags || "";
      },
      set(value) {
        if (!this.settings.public) {
          this.settings.public = {};
        }

        if (typeof this.settings.public.tags !== 'object' || !this.settings.public.tags) {
          this.settings.public.tags = { translate: { en: { reviewTags: '' }, ru: { reviewTags: '' }, ua: { reviewTags: '' } } };
        }

        this.settings.public.tags.reviewTags = value;
      },
    },

    isCatalogMod: {
      get() {
        if (!this.settings.public?.catalog_mod) {
          this.settings.public.catalog_mod = false
        }
        return this.settings.public.catalog_mod
      },
      set(value) {
        this.settings.public.catalog_mod = value;
      }
    },

    translateReviewTags: {
      get() {
        if (
          !this.settings.public?.tags?.translate ||
          typeof this.settings.public.tags.translate !== 'object'
        ) {
          this.settings.public.tags = {
            ...this.settings.public.tags,
            translate: {
              en: { reviewTags: '' },
              ru: { reviewTags: '' },
              ua: { reviewTags: '' },
            },
          };
        }
        return this.settings.public.tags.translate;
      },
      set(value) {
        if (!this.settings.public?.tags?.translate[this.selectLang]) {
          this.settings.public.tags.translate[this.selectLang] = { reviewTags: '' };
        }

        this.settings.public.tags.translate[this.selectLang].reviewTags = value;
      },
    },
  },

  watch: {
    'settings.public.maxReviewPhotos': function () {
      this.settings.env.MAX_FILE = this.settings.public.maxReviewPhotos;
    },
    settings: {
      handler(newVal, oldVal) {
        if (!this.settingsInitialized) {
          return;
        }

        this.areSettingsChanged = true;
      },
      deep: true
    }
  },

  methods: {
    validateToken() {
      api.post('/api/settings/valid', { token: this.settings.env.TELEGRAM_BOT_TOKEN })
        .then(response => response.data)
        .then(data => {
          this.$notify({
            title: this.$static('notify.settings-title', 'Налаштування'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 3000
          });
          if (data && data[3]) {
            this.settings.public = Object.assign(this.settings.public, { BOT_NAME: data[3] })
          }
        }).catch(err => {
          this.$notify({
            title: this.$static('notify.settings-title', 'Налаштування'),
            type: 'error',
            text: this.$static('notify.error', 'Помилка при збереженні данних'),
            duration: 3000
          });
        })
    },

    validateInteger(event, settingKey) {
      let value = event.target.value;
      // Заменяем запятую на точку
      value = value.replace(',', '.');
      // Преобразуем значение в число
      let numericValue = Number(value);
      // Получаем значения атрибутов min и max из инпута
      const min = Number(event.target.min);
      const max = Number(event.target.max);
      // Проверка на min и max
      if (numericValue < min) {
        numericValue = min;
      } else if (numericValue > max) {
        numericValue = max;
      }
      // Проверяем, является ли значение целым числом
      if (!Number.isInteger(numericValue)) {
        // Если не целое, убираем дробную часть
        this.settings.public[settingKey] = Math.floor(numericValue);
      } else {
        this.settings.public[settingKey] = numericValue;
      }
    },
    validateURL(input) {
      const urlPattern = new RegExp(
        '^(https?:\\/\\/)' + // Протокол (http или https) — обязателен
        '(([a-zA-Z\\d-]+\\.)+[a-zA-Z]{2,}|' + // Доменное имя должно включать хотя бы одну точку и домен верхнего уровня
        'localhost|' + // Локальный хост
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // Или IP-адрес (v4)
        '(\\:\\d+)?' + // Необязательный порт
        '(\\/[-a-zA-Z\\d%@_.~+&:]*)*' + // Путь
        '(\\?[;&a-zA-Z\\d%@_.,~+&:=-]*)?' + // Параметры
        '(\\#[-a-zA-Z\\d_]*)?$', // Хэш (якорь)
        'i'
      );

      return urlPattern.test(input);
    },

    validateBasicSettings() {
      let isValid = true;
      /* 1.Валидация ссылок на соц.сети */
      if (Array.isArray(this.settings.public.socialNetworks) && this.settings.public.socialNetworks.length > 0) {
        // Проверяем каждую ссылку в массиве
        isValid = this.settings.public.socialNetworks.every(socialNetwork => {
          if (!socialNetwork.link) {
            this.$notify({
              title: this.$static('notify.error-title', 'Помилка'),
              text: this.$static('s-b.no-social-link-error', 'Поле для посилання на соціальну мережу не заповнено'),
              type: 'error',
              duration: 3200
            });
            return false;
          }

          if (!this.validateURL(socialNetwork.link)) {
            this.$notify({
              title: this.$static('notify.error-title', 'Помилка'),
              text: this.$static('s-b.format-social-link-error',
                'Перевірте правильність введеного посилання для соцмереж.Також посилання не повинно містити недопустимих символів: < > " \' \\ {}[] | ^ ~ або пробілів.'),
              type: 'error',
              duration: 4000
            });
            return false;
          }
          return true;
        });
      }

      if (!isValid) return;

      /* 2.Валидация ссылки Web Hook */
      if (this.settings.env.WEBHOOK) {
        const isWebhookLinkValid = this.validateURL(this.settings.env.WEBHOOK)

        if (!isWebhookLinkValid) {
          this.$notify({
            title: this.$static('notify.error-title', 'Помилка'),
            text: this.$static('s-b.webhook-link-error',
              'Перевірте правильність введеного посилання для Web Hook.Також посилання не повинно містити недопустимих символів: < > " \' \\ {}[] | ^ ~ або пробілів.'),
            type: 'error',
            duration: 4000
          });
          return false;
        }
      }
      return true;
    },
    validateTelegramSettings() {
      /* 1.Валидация Телеграм Webhook ссылки */
      if (this.settings.env.TG_WEBHOOK) {
        const isWebhookLinkValid = this.validateURL(this.settings.env.TG_WEBHOOK)

        if (!isWebhookLinkValid) {
          this.$notify({
            title: this.$static('notify.error-title', 'Помилка'),
            text: this.$static('s-b.webhook-link-error2',
              'Перевірте правильність введеного посилання для Телеграм Webhook.Також посилання не повинно містити недопустимих символів: < > " \' \\ {}[] | ^ ~ або пробілів.'),
            type: 'error',
            duration: 4000
          });
          return false
        }
      }

      /* 2.Валидация ссылки на консультанта */
      if (this.settings.public.consultant) {
        const isConsultantLinkValid = this.validateURL(this.settings.public.consultant)

        if (!isConsultantLinkValid) {
          this.$notify({
            title: this.$static('notify.error-title', 'Помилка'),
            text: this.$static('s-b.consultant-link-error',
              'Перевірте правильність введеного посилання на консультанта.Також посилання не повинно містити недопустимих символів: < > " \' \\ {}[] | ^ ~ або пробілів.'),
            type: 'error',
            duration: 4000
          });
          return false
        }
      }
      /* 3.Валидация ссылки на telegram smart app */
      if (this.settings.env.TGLINK) {
        const isTGLinkValid = this.validateURL(this.settings.env.TGLINK)

        if (!isTGLinkValid) {
          this.$notify({
            title: this.$static('notify.error-title', 'Помилка'),
            text: this.$static('s-b.tg-link-error',
              'Перевірте правильність введеного посилання для Telegram Smart App.Також посилання не повинно містити недопустимих символів: < > " \' \\ {}[] | ^ ~ або пробілів.'),
            type: 'error',
            duration: 4000
          });
          return false
        }
      }
      /* ------------------ */

      return true;
    },

    validateBackofficeSettings() {
      /* 1.Валидация ссылки на Telegram Web App */
      if (this.settings.env.MANAGER_LINK) {
        const isManagerLinkValid = this.validateURL(this.settings.env.MANAGER_LINK)

        if (!isManagerLinkValid) {
          this.$notify({
            title: this.$static('notify.error-title', 'Помилка'),
            text: this.$static('s-b.manager-link-error',
              'Перевірте правильність введеного посилання для Telegram Web App.Також посилання не повинно містити недопустимих символів: < > " \' \\ {}[] | ^ ~ або пробілів.'),
            type: 'error',
            duration: 4000
          });
          return false
        }
      }
      /* ------------------ */
      return true;
    },

    getItems() {
      api.post('/api/item/filter', { filter: this.filter }).then(response => response.data).then(
        data => {
          this.items = data.result.map(x => {
            if (!x.advanced) {
              x.advanced = {}
            }
            return x
          });
        })
    },
    onChangeStatus(event, item) {
      // console.log(event, item);
      // console.log(event, item)
      // api.put('/api/callback', {id: item.id, status: event.value})
    },
    delImage() {
      this.settings.public = Object.assign(this.settings.public, { logo: undefined })
    },
    delFavicon() {
      this.settings.public = Object.assign(this.settings.public, { favicon: undefined })
    },
    openFileManager() {
      window.$('#file-manager').modal('show');

      this.$store.commit('onFileSelect', () => {
        let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
        this.settings.public = Object.assign(this.settings.public, { logo: images[0] })
      })
    },
    openFileManagerFavicon() {
      window.$('#file-manager').modal('show');

      this.$store.commit('onFileSelect', () => {
        let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
        this.settings.public = Object.assign(this.settings.public, { favicon: images[0] })
      })
    },
    removeLang(index) {
      this.settings.public.lang.splice(index, 1)
    },

    async fetchSettings() {
      this.load = true;
      try {
        const response = await api.get('/api/settings');
        let data = response.data;

        if (Array.isArray(data.env)) {
          data.env = {};
        }
        if (Array.isArray(data.public)) {
          data.public = {};
        }

        this.settings = data;
        this.$store.commit('setSettings', data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      } finally {
        this.load = false;
      }
    },

    async fetchMeta() {
      this.load = true;
      try {
        let response = await fetch('/storage/archive/lang.json');
        let data = await response.json();
        this.langLists = data;

        response = await fetch('/storage/archive/currency.json');
        data = await response.json();
        this.currList = data;
      } catch (error) {
        console.error('Error fetching meta data:', error);
      }
      finally {
        this.load = false;
      }
    },

    async saveSettings() {
      if (this.load) {
        return;
      }

      this.load = true;
      try {
        const resp = await api.post('/api/settings', { settings: this.settings });
        const data = resp.data;

        if (data) {
          this.$store.commit('setSettings', data);
          if (data.public && data.public.BOT_NAME) {
            let x = this.$store.getters.info;
            x.BOT_NAME = data.public.BOT_NAME;
            this.$store.commit('setInfo', x);
          }

          this.$notify({
            title: this.$static('notify.settings-title', 'Налаштування'),
            text: this.$static('notify.save', 'Збережено.'),
            duration: 1000
          });
        }
      } catch (error) {
        console.error('Error saving settings:', error);
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('notify.error', 'Помилка при збереженні данних.'),
          type: 'error',
          duration: 3000
        });
      } finally {
        this.load = false;
      }
    },

    async closeSettingsModalBox(modalBoxClass) {
      if (this.areSettingsChanged) {
        this.$notify({
          title: this.$static('notify.settings-title', 'Налаштування'),
          text: this.$static('notify.waiting-update', 'Зачекайте, йде оновлення данних'),
          type: 'info',
          duration: 1000
        });

        try {
          await this.fetchSettings();
          await this.fetchMeta();
          window.$('body').removeClass('is-hidden');
          window.$('.back-blur').removeClass('active');
          window.$('.' + modalBoxClass).removeClass('active');

          this.$notify({
            title: this.$static('notify.settings-title', 'Налаштування'),
            text: this.$static('notify.success-settings-update', 'Данi оновлено'),
            type: 'info',
            duration: 1000
          });

        } catch (error) {
          console.error('Error updating settings:', error);
          this.$notify({
            title: this.$static('notify.error-title', 'Помилка'),
            text: this.$static('notify.error2', 'Помилка при оновленнi данних'),
            type: 'error',
            duration: 2000
          });
        }

        this.areSettingsChanged = false;
      } else {
        window.$('body').removeClass('is-hidden');
        window.$('.back-blur').removeClass('active');
        window.$('.' + modalBoxClass).removeClass('active');
      }

      this.selectLang = "";

      //Возвращаем взад удаленного в SettingsModalBox слушателя, который нам мешал, но используется в функционале нашего ресурса.
      window.$('.back-blur').on('click', function () {
        window.$('body > .active').removeClass('active');
        window.$('body').removeClass('is-hidden');
      });
    },

    async handleSaveBtnClick(modalBoxClass, validationFunction) {
      if (validationFunction) {
        if (!validationFunction()) {
          return;
        }
      }

      await this.saveSettings();
      await this.closeSettingsModalBox(modalBoxClass);
    },

    addCustomField() {
      if (!Array.isArray(this.modal.fields)) {
        this.modal.fields = []
      }
      this.modal.fields.push({
        name: '', type: 'text', isRequired: false, enabled: true, order: this.modal.fields.length, translate: {
          en: { reviewTags: '' },
          ru: { reviewTags: '' },
          ua: { reviewTags: '' },
        }
      });
    },
    removeModalField(index) {
      this.modal.fields.splice(index, 1);
    },
    swap(index1, index2) {
      if (index2 > this.modal.fields.length - 1 || index2 < 0) {
        return
      }
      let list = [...this.modal.fields];
      list[index1].order = index2;
      list[index2].order = index1;
    },

    addSocialNetwork() {
      if (!Array.isArray(this.settings.public.socialNetworks)) {
        this.settings.public.socialNetworks = []; // Создаем массив, если его нет
      }

      this.settings.public.socialNetworks.push({
        name: '',
        link: ''
      })
    },
    removeSocialNetwork(index) {
      this.settings.public.socialNetworks.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.cs-trigger-info {
  border-radius: 50%;
  cursor: pointer;
  width: 18px;
  height: 18px;
  background-color: #e9e9e9;
  font-size: 12px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  text-align: center;
  margin: 0 5px;
}

.help-text2 {
  font-size: 14px
}

.bot-command-text {
  display: inline-block;
  color: #F63F3F;
  background-color: rgba(246, 63, 63, 0.15000000000000002);
  padding: 0px 6px;
  border-radius: 3px;
  line-height: 22px;
}
</style>